import styled from 'styled-components';
import { Space } from 'antd';

export const TravelTypeSpaceStyled = styled(Space)`
  grid-area: travel-type;
  .ant-select-selector {
    min-width: 176px;
  }
`;

export const MapRouteSpaceStyled = styled(Space)`
  grid-area: map-route;
  justify-content: flex-end;
`;

export const ColFormStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
